import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgCarrierChoice = (props) => /* @__PURE__ */ _jsxs("svg", {
	id: "carrierChoice",
	xmlns: "http://www.w3.org/2000/svg",
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		id: "Group_17297",
		"data-name": "Group 17297",
		transform: "translate(0 -3)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12641",
				"data-name": "Path 12641",
				d: "M8.121,14.879a3,3,0,1,1-4.243,0,3,3,0,0,1,4.243,0",
				transform: "translate(0 -1)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12642",
				"data-name": "Path 12642",
				d: "M18.5,9.5,21,7,18.5,4.5",
				transform: "translate(0 1)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12647",
				"data-name": "Path 12647",
				d: "M18.5,9.5,21,7,18.5,4.5",
				transform: "translate(0 15)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12645",
				"data-name": "Path 12645",
				d: "M21,14H16c-1.657,0-3-.94-3-2.1V9.1C13,7.94,11.657,7,10,7H9",
				transform: "translate(0 8)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			}),
			/* @__PURE__ */ _jsx("path", {
				id: "Path_12646",
				"data-name": "Path 12646",
				d: "M21,7H16c-1.657,0-3,.94-3,2.1v2.8c0,1.16-1.343,2.1-3,2.1H9",
				transform: "translate(0 1)",
				fill: "none",
				stroke: "currentColor",
				strokeLinecap: "round",
				strokeLinejoin: "round",
				strokeWidth: 1.5
			})
		]
	}), /* @__PURE__ */ _jsx("path", {
		id: "Path_12644",
		"data-name": "Path 12644",
		d: "M0,0H24V24H0Z",
		fill: "none"
	})]
});
export default SvgCarrierChoice;
